import ReactGA from "react-ga4"; // Google Analytic


export default function GoogleAnalytics(category_a,action_a,label_a) {
    
    ReactGA.event({
        category:category_a,
        action:action_a,
        label: label_a,
    })
}